import apiClient from '@/services/axios'

export async function post(documentTemplateId) {
  var response = await apiClient({
    method: 'post',
    url: '/certificates/' + documentTemplateId + '/pdf',
    responseType: 'blob'
  })

  if (response) {
    return response.data
  }

  throw new Error('Unable to export certificate to PDF.')
}